<template>
  <div class="card mb-4 card-body py-3">
    <h3 class="mb-0 t-400">
      {{ title }}
      <i v-if="icon" :class="`${icon} d-block pull-right t-secondary`"></i>
    </h3>
    <div class="mt-3">
      <ul class="list-unstyled mb-0 flex-wrap d-flex">
        <li v-for="(label, index) in labels" :key="index"
          class="badge badge-pill badge-secondary--white mr-2 mb-2 bd-radius word-overflow position-relative"
          v-tooltip="`${label}`"
        >{{ label }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'labelCard',
  props: {
    labels: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>
